import { tv, type VariantProps } from "tailwind-variants";

export const heroParallaxVariants = tv({
  slots: {
    base: [
      "relative",
      "w-full h-screen lg:h-[calc(100dvh+120px)]",
      "overflow-hidden",
      "mb-0 lg:mb-2",
    ],
    container: ["container-fluid", "h-full"],
    wrapper: ["relative", "flex", "w-full", "h-full"],
    floatingImagesWrapper: ["absolute top-0 left-0 w-full h-full z-9"],
    content: [
      "relative z-10 flex flex-col items-center justify-center",
      "w-full h-[calc(100dvh-120px)] p-8 max-w-3xl mx-auto",
      "pointer-events-none",
    ],
    title: ["text-text-neutral-default", "max-w-3xl", "text-center", "mx-auto"],
    description: ["mt-4 text-center"],
    bg: [
      "absolute z-1 inset-0 bottom-12 blur-[40px]",
      "bg-[linear-gradient(166deg,rgba(255,255,255,0.6)_41.76%,rgba(130,218,230,0.6)_104.95%)]",
      "dark:!hidden",
    ],
  },
});

export type HeroParallaxVariantProps = VariantProps<typeof heroParallaxVariants>;
export type HeroParallaxReturnVariantProps = ReturnType<typeof heroParallaxVariants>;
